import { useEffect, useState, useRef } from 'react';
import { AggregateCollector } from '../utils/FPSMeasurement';

export const useFPS = (enabled: boolean = true) => {
  const [fps, setFps] = useState(0);
  const collectorRef = useRef<AggregateCollector | null>(null);

  useEffect(() => {
    if (!enabled) {
      if (collectorRef.current) {
        collectorRef.current.stop();
        collectorRef.current = null;
      }
      setFps(0);
      return;
    }

    collectorRef.current = new AggregateCollector(setFps);
    collectorRef.current.start();

    return () => {
      if (collectorRef.current) {
        collectorRef.current.stop();
      }
    };
  }, [enabled]);

  return fps;
};
